import Vue from "vue";
import Vuex from "vuex";
import main from "./main";
const store = new Vuex.Store({
  state: main.state,
  mutations: main.mutations,
  actions: main.actions,
  getters: main.getters
});
Vue.use(Vuex);
export default store;